import React from "react"
import { string, shape } from "prop-types"
import classnames from "classnames"
import ThemeConsumer from "../ThemeConsumer"

const Input = (props) => {
  const { theme, preset, classNames, ...rest } = props

  const classes = classnames(classNames, theme.input, {
    [theme[preset]]: preset
  })

  return <input {...rest} className={classes} />
}

Input.propTypes = {
  preset: string,
  theme: shape({
    preset: string
  }),
  classNames: string
}

Input.defaultProps = {
  theme: {},
  preset: "main"
}

export default ThemeConsumer("UIInput")(Input)



// WEBPACK FOOTER //
// ./src/shared/components/Input/index.js